import { sassmallRequest } from "./client";

export function pageSassmallSiteMessages(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>("/notices/siteMessage/page", { method: "POST", body: payload });
}

export function markSassmallSiteMessageRead(receiptId: string) {
  return sassmallRequest("/notices/siteMessage/markRead", { method: "POST", body: { receiptId } });
}

export function pageSassmallShopAnnouncements(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>("/notices/shopAnnouncement/page", { method: "POST", body: payload });
}

export function getSassmallShopAnnouncementDetail(id: string | number) {
  return sassmallRequest<Record<string, any>>(`/notices/shopAnnouncement/${encodeURIComponent(String(id))}`, { method: "GET" });
}
